module.exports = __webpack_public_path__ + "static/media/poker-face-possum.8934bfd7.jpg";